import { useRef, useState } from "react";
import { ImageSquare, X, CircleNotch } from "@phosphor-icons/react";
import api, { mediaUrl } from "../lib/api";
import { toast } from "sonner";

export const ImageUploader = ({ paths, onChange, testid = "image-uploader" }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const pick = () => inputRef.current?.click();

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    try {
      const form = new FormData();
      files.forEach((f) => form.append("files", f));
      const res = await api.post("/admin/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const newPaths = res.data.files.map((f) => f.path);
      onChange([...(paths || []), ...newPaths]);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Image upload failed");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = (p) => onChange((paths || []).filter((x) => x !== p));

  return (
    <div data-testid={testid}>
      {paths && paths.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-3">
          {paths.map((p) => (
            <div key={p} className="relative w-20 h-20 rounded-xl overflow-hidden border border-[#E6EBE4]" data-testid="upload-thumb">
              <img src={mediaUrl(`/api/files/${p}`)} alt="upload" className="w-full h-full object-cover" />
              <button
                type="button"
                onClick={() => remove(p)}
                className="absolute top-1 right-1 bg-[#2C362B]/70 text-white rounded-full p-0.5 hover:bg-[#D97B6A]"
                data-testid="remove-thumb-btn"
              >
                <X size={12} weight="bold" />
              </button>
            </div>
          ))}
        </div>
      )}
      <input ref={inputRef} type="file" accept="image/*" multiple onChange={handleFiles} className="hidden" data-testid="image-file-input" />
      <button
        type="button"
        onClick={pick}
        disabled={uploading}
        className="flex items-center gap-2 text-sm font-semibold text-[#5E6C5C] bg-[#F4F1E8] hover:bg-[#EAE6D9] rounded-full px-4 py-2 transition-colors disabled:opacity-60"
        data-testid="add-photo-btn"
      >
        {uploading ? <CircleNotch size={16} className="animate-spin" /> : <ImageSquare size={16} weight="duotone" />}
        {uploading ? "Uploading…" : "Add photos"}
      </button>
    </div>
  );
};
